import { createHead, UnheadProvider } from '@unhead/react/client'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import WalletProvider from './components/WalletProvider.tsx'
import { applyLiveListingReset } from '@/lib/liveReset'
import './index.css'

applyLiveListingReset()

const head = createHead()

createRoot(document.getElementById('root')!).render(
  <UnheadProvider head={head}>
    <WalletProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </WalletProvider>
  </UnheadProvider>
)
